<template>
  <Screen :back="false" title="folding directions">
    <!-- Heading -->
    <div class="fd-heading-area">
      <h2 class="fd-heading" aria-label="Folding Directions">
        <span class="fd-heading__shadow">Folding Directions</span>
        <span class="fd-heading__text">Folding Directions</span>
      </h2>
    </div>

    <!-- Video grid -->
    <div class="fd-grid">
      <div class="fd-card" v-for="fold in folds" :key="fold.name">
        <p class="fd-card__label">{{ fold.label }}</p>
        <video
          class="fd-card__video"
          :src="fold.video"
          :poster="fold.poster"
          controls
          playsinline
          preload="metadata"
        ></video>
        <button class="fd-card__browser-btn" @click="openInBrowser(fold.video)">
          Open in browser
        </button>
      </div>
    </div>

    <AppFooter currentScreen="FoldingDirectionsScreen" />

    <!-- Back button in nav -->
    <template v-slot:action>
      <button class="back-btn" @click="$store.commit('setScreen', 'ChooseFoldScreen')">
        <ChevronLeft :size="16" />
        <span>Back to choose folds</span>
      </button>
    </template>
  </Screen>
</template>

<script>
import Screen from './Screen.vue';
import AppFooter from './AppFooter.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue';

export default {
  name: 'FoldingDirectionsScreen',
  components: { Screen, ChevronLeft, AppFooter },
  data() {
    return {
      folds: [
        {
          name: 'trifold',
          label: 'Trifold',
          video:  require('../assets/videos/trifold/trifold.mp4'),
          poster: require('../assets/videos/trifold/trifold.jpg')
        },
        {
          name: 'bifold-vertical',
          label: 'Bifold Vertical',
          video:  require('../assets/videos/bifold-vertical/bifold-vertical.mp4'),
          poster: require('../assets/videos/bifold-vertical/bifold-vertical.jpg')
        },
        {
          name: 'quarter-fold',
          label: 'Quarter Fold',
          video:  require('../assets/videos/quarterfold/quarterfold.mp4'),
          poster: require('../assets/videos/quarterfold/quarterfold.jpg')
        },
        {
          name: 'bifold-easel',
          label: 'Bifold Easel',
          video:  require('../assets/videos/bifold-easel/bifold-easel.mp4'),
          poster: require('../assets/videos/bifold-easel/bifold-easel.jpg')
        }
      ]
    };
  },
  methods: {
    openInBrowser(src) {
      window.open(src, '_blank');
    }
  }
}
</script>

<style scoped>
/* ── Hide default nav title — heading is custom ── */
:deep(.title) {
  display: none;
}

/* ── Heading area ── */
.fd-heading-area {
  text-align: center;
  padding: 24px 16px 8px;
  flex-shrink: 0;
}

.fd-heading {
  position: relative;
  font-family: Cabin-Sketch, cursive;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 64px;
  line-height: 1.1;
  margin: 0 auto 24px;
}

.fd-heading__shadow {
  position: absolute;
  left: 6px;
  top: 6px;
  width: 100%;
  color: var(--surface-darkest);
}

.fd-heading__text {
  position: relative;
  color: var(--green-lightest);
}

/* ── Video grid ── */
.fd-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px 32px;
  padding: 8px 0 48px;
  width: 80%;
  max-width: 900px;
  margin: 0 auto;
  box-sizing: border-box;
  flex: 1;
}

/* ── Video card ── */
.fd-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.fd-card__label {
  font-family: var(--font-family-balsamiq);
  font-size: 18px;
  font-weight: 700;
  color: var(--text-lightest);
  margin: 0;
  text-align: center;
}

.fd-card__video {
  width: 100%;
  display: block;
  border-radius: 2px;
  background-color: var(--surface-darkest);
  border: 2px solid var(--text-bright);
}

.fd-card__browser-btn {
  align-self: flex-end;
  font-family: var(--font-family-balsamiq);
  font-size: 13px;
  line-height: 1.5;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--text-bright);
  text-decoration: underline;
  text-decoration-skip-ink: none;
  cursor: pointer;
}

.fd-card__browser-btn:hover {
  color: var(--text-lightest);
}

/* ── Back button ── */
.back-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: var(--font-family-balsamiq);
  font-size: 14px;
  line-height: 24px;
  padding: 4px 12px 4px 8px;
  border-radius: 1px;
  border: 2px solid var(--text-bright);
  background-color: var(--surface-darkest);
  color: var(--text-bright);
  filter: url(#button-stroke);
  cursor: pointer;
  white-space: nowrap;
}

.back-btn:hover {
  background-color: var(--surface-dark);
}

/* ── Mobile (≤ 560px): single column, 32px gap ── */
@media screen and (max-width: 560px) {
  .fd-heading {
    font-size: 36px;
  }

  .fd-heading__shadow {
    left: 3px;
    top: 3px;
  }

  .fd-grid {
    grid-template-columns: 1fr;
    gap: 32px;
    padding: 8px 16px 32px;
    width: 100%;
  }

}
</style>
